import { render, staticRenderFns } from "./InceptionAiAssessmentIndex.vue?vue&type=template&id=2384dca3&scoped=true"
import script from "./InceptionAiAssessmentIndex.vue?vue&type=script&lang=ts"
export * from "./InceptionAiAssessmentIndex.vue?vue&type=script&lang=ts"
import style0 from "./InceptionAiAssessmentIndex.vue?vue&type=style&index=0&id=2384dca3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2384dca3",
  null
  
)

export default component.exports